import { render, staticRenderFns } from "./OrganizerCreateTickets.vue?vue&type=template&id=1a701b33&"
import script from "./OrganizerCreateTickets.vue?vue&type=script&lang=js&"
export * from "./OrganizerCreateTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports